import React from 'react';
import './Footer.css'; // adăugăm un fișier CSS pentru stilizare

export default function Footer() {
    return (
        <div className="footer-container">
            <div className="container text-center">
                <div className="row">
                    <div className="col">
                        <h4>Termeni și Condiții</h4>
                        <p>Toate informațiile și materialele folosite în acest site sunt rezervate în exclusivitate OptiZak Brașov.</p>
                        <p>Folosirea oricărui text, imagine, material, fișier sau obiect de construcție din acest site în alte scopuri decât cele necomerciale și cele specificate în site fără acordul scris al NEST este interzisă, fiind protejate de legea dreptului de autor.</p>
                    </div>
                    
                    <div className="col">
                        <h4>Contact</h4>
                        <p>Strada 13 Decembrie nr. 24, Brașov</p>
                        <p>+40 727 700 008</p>
                        <p>optizak@yahoo.com</p>
                        <p>optizak@gmail.com</p>
                    </div>
                </div>
            </div>
            <footer className="footer-bottom">
                <small>
                    Copyright © 2024 OptiZak. All Rights Reserved.
                </small>
            </footer>
        </div>
    );
}
